<template>
  <CrudList
    title="Etiquetas"
    storeName="Tags"
    labelAddNew="Agregar"
    slot-scope="{ item }"
    sortable
    canSearch
    next-link="/admin/rent_trakers"
    :breadcrumbs="[
      {
        text: 'Spots y vehículos',
        disabled: false,
        href: '/admin/tags'
      },
      {
        text: 'Etiquetas',
        disabled: false,
        href: '#'
      },
    ]"
  >
  </CrudList>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: { CrudList },
};
</script>
